
import { defineComponent, onBeforeMount, watch, ref } from 'vue';
import { VueQueryDevTools } from 'vue-query/devtools';
import { useStore } from 'vuex';
import { useRoute, useRouter } from 'vue-router';
import BigNumber from 'bignumber.js';
import * as Layouts from '@/pages/_layouts';
import useWeb3Watchers from '@/composables/watchers/useWeb3Watchers';
import WalletSelectModal from '@/components/web3/WalletSelectModal.vue';
import useWeb3 from '@/services/web3/useWeb3';
import { DEFAULT_TOKEN_DECIMALS } from '@/constants/tokens';
import Notifications from '@/components/notifications/Notifications.vue';
import useGnosisSafeApp from './composables/useGnosisSafeApp';
import useGlobalQueryWatchers from './composables/watchers/useGlobalQueryWatchers';
import usePoolCreationWatcher from './composables/watchers/usePoolCreationWatcher';
import useAlerts, {
  Alert,
  AlertPriority,
  AlertType
} from './composables/useAlerts';
import { useI18n } from 'vue-i18n';
import useExploitWatcher from './composables/watchers/useExploitWatcher';

BigNumber.config({ DECIMAL_PLACES: DEFAULT_TOKEN_DECIMALS });

export default defineComponent({
  components: {
    ...Layouts,
    VueQueryDevTools,
    WalletSelectModal,
    Notifications
  },

  setup() {
    /**
     * STATE
     */
    const layout = ref('DefaultLayout');

    /**
     * COMPOSABLES
     */
    useWeb3Watchers();
    usePoolCreationWatcher();
    useGlobalQueryWatchers();
    useGnosisSafeApp();
    useExploitWatcher();
    const {
      isWalletSelectVisible,
      toggleWalletSelectModal
      // isMainnet
    } = useWeb3();
    const route = useRoute();
    const store = useStore();
    // const router = useRouter();
    // const { addAlert } = useAlerts();
    // const { t } = useI18n();

    // console.log('isMainnet.value', isMainnet.value);

    // Temporary feature alert for Balancer boosted pools.
    // if (isMainnet.value) {
    //   const featureAlert: Alert = {
    //     id: 'boosted-pools',
    //     priority: AlertPriority.LOW,
    //     label: t('alerts.boostedPools'),
    //     type: AlertType.FEATURE,
    //     actionOnClick: true,
    //     action: () =>
    //       router.push({
    //         name: 'pool',
    //         params: {
    //           id:
    //             '0xdb301c1ac91f6a5caf49c79249b676c44e93f37a0000000000000000000007ea'
    //         },
    //         query: {
    //           utm_source: 'website',
    //           utm_medium: 'banner',
    //           utm_campaign: 'aaveboostedpools'
    //         }
    //       })
    //   };
    //   addAlert(featureAlert);
    // }

    /**
     * CALLBACKS
     */
    onBeforeMount(async () => {
      store.dispatch('app/init');
    });

    /**
     * WATCHERS
     */
    watch(route, newRoute => {
      if (newRoute.meta.layout) {
        layout.value = newRoute.meta.layout as string;
      } else {
        layout.value = 'DefaultLayout';
      }
    });

    return {
      // state
      layout,
      // computed
      isWalletSelectVisible,
      // methods
      toggleWalletSelectModal
    };
  }
});
